import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { PopUpForm } from "../../../../../common/popup/popUpForm/popUpForm";
import { MasterTerminalForm } from "./form/form";

import { PopUpCodes } from "../../../../../../common/enum/PopUpCodes";
import { setShowPopUpMaster } from "../../../../../../redux/reducers/resources/master/master";
import { postToMasterTerminalForm } from "../../../../../../redux/actions/resources/master/terminal/terminal";
import { resetMasterTerminalForm } from "../../../../../../redux/reducers/resources/master/terminal/form";
import { RequiredFieldsMessage } from "../../../../../common/requiredMessage/requiredMessage";
interface IMasterTransportUnitControllerForm {
    widthPopUp: any;
    heigthPopUp: any;
}
export const MasterTerminalFormController: React.FC<IMasterTransportUnitControllerForm> = ({ widthPopUp, heigthPopUp }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation("common", { keyPrefix: "MASTERS" });

    const { showPopUp } = useAppSelector((state) => state.masterPopUp);
    const { form, loading } = useAppSelector((state) => state.masterTerminalForm);

    const onAcceptPopUp = () => {
        dispatch(postToMasterTerminalForm()).then((response: any) => {
            if (response) {
                onCancelPopUp();
            }
        });
    };

    const onCancelPopUp = () => {
        dispatch(setShowPopUpMaster(PopUpCodes.NONE));
    };

    const onDimissed = () => {
        dispatch(resetMasterTerminalForm());
    };
    const titlePopUp = useMemo(() => {
        let title = "";
        if (showPopUp === PopUpCodes.CREATE) {
            title = t("CREATE") + " " + t("BUTTON.TERMINAL");
        } else if (showPopUp === PopUpCodes.UPDATE) {
            title = t("UPDATE") + " " + t("BUTTON.TERMINAL");
        }
        return title;
    }, [showPopUp]);

    const isDisabledButton = useMemo(() => {
        return !form.code || !form.description;
    }, [form]);

    return (
        <PopUpForm
            content={<MasterTerminalForm />}
            title={titlePopUp}
            isVisible={showPopUp === PopUpCodes.CREATE || showPopUp === PopUpCodes.UPDATE ? true : false}
            onCancel={onCancelPopUp}
            onSave={onAcceptPopUp}
            height={heigthPopUp}
            width={widthPopUp}
            isDisabledButton={isDisabledButton}
            isLoading={loading}
            onDimissed={onDimissed}
            leftButtonContent={<RequiredFieldsMessage />}
        />
    );
};
